module.exports = "/1st/2026/packs/i_narrow_down02-755d6813a30240ff74c28c966df94066.svg";